import { NotificationConfiguration } from '../notification.templates';

export const CR_FINALIZE_CIRCULAR_RESOLUTION_TEMPLATE: NotificationConfiguration = {
  inapp: `The circular resolution is <b>final</b>.`,
  email: {
    ctaKey: 'go_to_cr',
  },
};
